import { React } from 'react';
import { Flex, Box, Text, Textarea } from '@chakra-ui/react';
import TooltipIcon from './TooltipIcon';

function TextAreaBox({ title, helpText, height, value, onChange, width }) {
  return (
    <Box width={width}>
      <Flex alignItems='center' mb={title && '12px'}>
        {title && <Text fontSize='12px'>{title}</Text>}
        {helpText && <TooltipIcon helpText={helpText} />}
      </Flex>
      <Textarea
        fontSize='12px'
        border='1px solid #D0D0D0'
        borderRadius='20px'
        bg='gray.50'
        p='8px 16px'
        height={height}
        width={width}
        value={value || ''}
        onChange={onChange}
      />
    </Box>
  );
}

export default TextAreaBox;
